
<div
  v-show="content.cacheParDefaut && content.cacheParDefaut == 'false'"
  :id="content.idHTML"
  class="col d-flex flex-column"
  :class="[jel_getClassObject(content), { 'justify-content-center': !content.justifie }]"
>
  <EditableArea
    v-if="content.column"
    :class="[{ container: !retirerConteneur }, content.classeCssConteneur]"
    :content="content.column"
    :parentTemplateId="metadata['mgnl:template']"
  />
</div>
